module.exports = __webpack_public_path__ + "static/media/EICLIT.a4f0fb0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/EICLIT.jpg
// module id = 1737
// module chunks = 1